export async function registerServiceWorker(): Promise<void> {
  if ('serviceWorker' in navigator) {
    await navigator.serviceWorker.register('/service-worker.js');
  } else {
    throw new Error('This website requires ServiceWorker support.');
  }
}
